export default "__VITE_ASSET__BsdDdzjv__"